<template>
    <div class=''>
        <div v-if="reload">
            <goldDetailTable :parentData="parentData" :goldData.sync="goldData"></goldDetailTable>
            <goldDetailFlowDetail :parentData="parentData" :goldData.sync="goldData" v-if="way=='buyer'&&(fromType?(fromType==4||fromType==3):'true')" style="margin:30px 0 50px 0;"></goldDetailFlowDetail>
            <goldDetailFlowRecord :parentData="parentData" :goldData.sync="goldData" v-if="(fromType?(fromType==2||fromType==5):'true')" style="margin:30px 0;"></goldDetailFlowRecord>
            <goldDetailOriginInfo :parentData="parentData" :goldData.sync="goldData"></goldDetailOriginInfo>
            <goldDetailOtherFile></goldDetailOtherFile>
            <goldDetailApproveHistory></goldDetailApproveHistory>
            <div class="spaceCenter" v-if="backBtn">
                <a-button class="btn-blue-line" style="margin:30px 0;width:100px;" @click="goBack()">返回</a-button>
            </div>
        </div>
    </div>
</template>

<script>
import goldDetailTable from "@/components/gold-page/gold-detail-table"
import goldDetailFlowDetail from "@/components/gold-page/gold-detail-flow-detail"
import goldDetailFlowRecord from "@/components/gold-page/gold-detail-flow-record"
import goldDetailOriginInfo from "@/components/gold-page/gold-detail-origin-info"
import goldDetailOtherFile from "@/components/gold-page/gold-detail-other-file"
import goldDetailApproveHistory from "@/components/gold-page/gold-detail-approve-history"
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import {getDetailApi} from '@/api/gold.js'
export default {
    props:{
        backBtn:{
            type:Boolean,
            required: false,
            default: function () {
                return true;
            },
        }
    },
    name:"gold-detail",
    data() {
        return {
            reload:true,
            fromType:null,
            goldData:{}
        }
    },
    components:{
      goldDetailTable,
      goldDetailFlowRecord,
      goldDetailFlowDetail,
      goldDetailOriginInfo,
      goldDetailOtherFile,
      goldDetailApproveHistory
    },
    computed: {
        ...mapGetters({
            userObj:"home/getUserObj",
            parentData:"app/getGoldDetailPrarms"
        }),
        way(){
            if(this.parentData){
                return this.parentData.way;
            }
            return this.$route.params.way;
        },
        gldId(){
            if(this.parentData && this.parentData.way == 'rcvb'){
                return this.parentData.goldObj.gldId;
            }
            if(this.parentData){
                return this.parentData.gldId;
            }
            return this.$route.params.gldId;
        },
    },
    methods: {
        ...mapMutations({
            setBuyOrSell:"app/setBuyOrSell",
        }),
        getGoldDetail(){
            if(this.way == 'rcvb'){
                this.getGoldDetailRcvb();
                return;
            }
            let param = {
                way:this.way,
                gldId:this.gldId
            }
            getDetailApi(param,true)
            .then(res => {
                this.goldData = res.data;
                // 设置卖方详情还是买方详情
                if(this.$route.path.indexOf('buyer') > -1){
                    this.setBuyOrSell('buyer');
                }else{
                    this.setBuyOrSell('seller');
                }
            }).catch(err => { console.log(err);});
        },
        getGoldDetailRcvb(){ //融资页面点击查看祺信详情
            let param = {...this.parentData.goldObj}
            getDetailApi(param,true)
            .then(res => {
                this.goldData = res.data;
            }).catch(err => { console.log(err);});
        },
        goBack(){
            if(this.$route.query.fromPath){
                this.MENUAPI.goToOneTab({
                    path: this.$route.query.fromPath,
                    noMenu:this.$route.query.noMenu
                });
            }else{
                this.$router.go(-1);
            }
        },


    },
    created() {
        if(this.$route.params&&this.$route.params.fromType){
            this.fromType = this.$route.params.fromType;
        }

        this.getGoldDetail();
    },
    mounted() {},
    watch: {},
    activated() {
        if(this.parentData && this.parentData.refresh){
            this.reload = false;
            this.$nextTick(()=>{
                this.reload = true;
            })
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/gold-page/gold-detail.vue